import { render, staticRenderFns } from "./ReturnsTable.vue?vue&type=template&id=1dd1320a&"
import script from "./ReturnsTable.vue?vue&type=script&lang=ts&"
export * from "./ReturnsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports